import type { AppState } from '@store/store';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

type NavigationMode = 'hidden' | 'collapsed' | 'expanded';

export function useNavigationState() {
    const width = useSelector((state: AppState) => state.windowSize.width);
    const isMobile = width <= 768;

    const [navMode, setNavMode] = useState<NavigationMode>(() => {
        if (width <= 768) return 'hidden';
        if (width <= 1200) return 'collapsed';
        return 'expanded';
    });

    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

    const toggleNav = useCallback(() => {
        if (isMobile) {
            setMobileSidebarOpen(true);
        } else {
            setNavMode((prev) => (prev === 'collapsed' ? 'expanded' : 'collapsed'));
        }
    }, [isMobile]);

    useEffect(() => {
        if (width <= 768) {
            setNavMode('hidden');
            setMobileSidebarOpen(false);
        } else if (width <= 1200) {
            setNavMode('collapsed');
        } else {
            setNavMode('expanded');
        }
    }, [width]);

    return {
        navMode,
        setNavMode,
        mobileSidebarOpen,
        setMobileSidebarOpen,
        toggleNav,
        isMobile,
    };
}
